import React, {Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {setCurrentNavPage} from "actions";
import PageHeader from "../../components/common/PageHeader/PageHeader";
import DocumentApplicationFilters from "../../components/Filters/Statistics/DocumentApplicationFilters";
import FacturationStatisticsBloc from "../../components/Admin/statisctics/FacturationStatisticsBloc";
import PaymentStatisticsBloc from "../../components/Admin/statisctics/PaymentStatisticsBloc";
import NotPaidInvoices from "../../components/Admin/statisctics/NotPaidInvoices";
import {reactSelectStyles, urlFiltersParser, updateUrlFilter} from 'utils';
import _ from "i18n";
import {fetchDocumentsAppRef} from "../../actions/thunks/documents"
import queryString from "query-string";
import {castArray} from "lodash";
import { setCurrentClient } from '../../actions/actions/auth';

class StatisticIFramePage extends Component {


  constructor(props) {
    super(props);

    this.state = {
      header: "",
      showTitle : true,
    };
  }

    componentDidMount() {
    this.props.setCurrentNavPage("STATISTICS-IFRAME");
    let appRefsFilter = this.initFromFilter('appRefs');
    let clientIdFilter = this.initFromFilter('clientId');
    let showTitle = this.initFromFilter('showTitle');

    if(showTitle[0]) {
      this.setState({showTitle : showTitle[0]});
    }

      let { paymentClients } = this.props.auth.user;

      clientIdFilter.forEach(id => {
        if(paymentClients.length > 0) {

          let organization = paymentClients.find(item => item.id == id);

          if(organization !== undefined) {
            this.props.setCurrentClient(organization);
          }
        }
      })

      if(showTitle[0] && showTitle[0] == '1') {
        this.props.fetchDocumentsAppRef(this.props.auth.currentClient ? this.props.auth.currentClient.id : null).then(() => {
          appRefsFilter.forEach(id => {
            if(this.props.appRef.length > 0) {
              let appRefs = this.props.appRef.find(item => item.id == id);
              if(appRefs !== undefined) {
                this.setState({header : appRefs.nameFr})
              }
            }
          });
        })
      }
   }


  componentDidUpdate(prevProps, prevState) {

    if(prevProps.auth.currentClient !== this.props.auth.currentClient) {
      let appRefsFilter = this.initFromFilter('appRefs');
      this.props.fetchDocumentsAppRef(this.props.auth.currentClient ? this.props.auth.currentClient.id : null).then(() => {
        appRefsFilter.forEach(id => {
          if(this.props.appRef.length > 0) {
            let appRefs = this.props.appRef.find(item => item.id == id);
            if(appRefs !== undefined) {
              this.setState({header : appRefs.nameFr})
            }
          }
        });
      })    }
  }

  initFromFilter = (group) => {
    const urlParams   = queryString.parse(location.search);

    if(!urlParams.filters) {
      return [];
    }

    let filter = urlFiltersParser(urlParams.filters);

    if(!filter || filter.length <= 0) {
      return [];
    }

    let appFilter = filter.filter(item => group === item.property);

    if (!appFilter || appFilter.length <= 0 || !appFilter[0].value) {
      return [];
    }
    return castArray(appFilter[0].value);

  };

  render() {

    return (
      <div>
        {this.state.showTitle == '1' ? <PageHeader
          header={_('stats')}
          subHeader={this.state.header}
          icon="STATISTICS_HEADER"
        /> : null }

        <div className="ttp-tab-container">
          <div className="ttp-tab-selector hidden">
            <DocumentApplicationFilters/>
          </div>
          <FacturationStatisticsBloc showInNewTab = {true}/>

          <PaymentStatisticsBloc showInNewTab = {true}/>

          <NotPaidInvoices/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({

  appRef: state.appRefFilter.items,
  auth: state.auth,
});

const mapDispatchToProps = {
  setCurrentNavPage,
  fetchDocumentsAppRef,
  setCurrentClient
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticIFramePage);



// WEBPACK FOOTER //
// ./app/pages/Admin/StatisticIFramePage.js